import {descend, isNotNil} from 'ramda';

import {ListVehicleAlbumsApiResponse, VehicleAlbums} from '@dms/api/shared';

import {Nullish} from 'shared/web';

import {HistoricalServiceCaseAlbum} from '../types/HistoricalServiceCaseAlbum';

// Service-album is intentionally not a source here: service-case photos live in the vehicle-album
// PHOTOS_SERVICE_CASE bucket, which is the only bucket this view reads.
export function buildServiceCaseAlbumGroups(
  vehicleAlbums: ListVehicleAlbumsApiResponse | Nullish,
  ignoredServiceCaseId: string | Nullish
): HistoricalServiceCaseAlbum[][] {
  const albums: HistoricalServiceCaseAlbum[] = (vehicleAlbums ?? [])
    .flatMap((album) =>
      album.name === VehicleAlbums.PHOTOS_SERVICE_CASE && album.serviceCaseId !== null
        ? [
            {
              id: album.id,
              translation: album.translation,
              serviceCaseId: album.serviceCaseId,
              createdAt: album.createdAt,
              photoCount: album.photoCount,
            },
          ]
        : []
    )
    .filter(
      (album): album is HistoricalServiceCaseAlbum =>
        isNotNil(album.serviceCaseId) && album.serviceCaseId !== ignoredServiceCaseId
    )
    .toSorted(descend((album) => album.createdAt));

  return Object.values(
    albums.reduce<Record<string, HistoricalServiceCaseAlbum[]>>((acc, album) => {
      acc[album.serviceCaseId] = [...(acc[album.serviceCaseId] ?? []), album];
      return acc;
    }, {})
  ).toSorted(descend((albumGroup) => albumGroup[0]?.createdAt ?? ''));
}
